module.exports = __webpack_public_path__ + "static/media/greenhouse3-13.f631138e.webp";